export enum BestInDentalStatus {
  Applicant = 'applicant',
  Nominee = 'nominee',
  NotEntered = 'not-entered',
  Rejected = 'rejected',
  Winner = 'winner',
}
